import { formatDays, formatTimeDisplay } from './coverageHoursTeamUtils';
import { CoverageHoursDayOfWeek } from './useCoverageHours';

const DAY_CODE_BY_PROTO_NAME: Record<CoverageHoursDayOfWeek, string> = {
  DAY_OF_WEEK_SUNDAY: 'SUN',
  DAY_OF_WEEK_MONDAY: 'MON',
  DAY_OF_WEEK_TUESDAY: 'TUE',
  DAY_OF_WEEK_WEDNESDAY: 'WED',
  DAY_OF_WEEK_THURSDAY: 'THU',
  DAY_OF_WEEK_FRIDAY: 'FRI',
  DAY_OF_WEEK_SATURDAY: 'SAT',
};

type CoverageHoursSchedule = {
  daysOfWeek: string[];
  startMinute: number;
  endMinute: number;
};

export function toDayCodes(daysOfWeek: string[]): string[] {
  return daysOfWeek.map(day => {
    const code = DAY_CODE_BY_PROTO_NAME[day as CoverageHoursDayOfWeek];

    // A day silently dropped from a schedule is as wrong as a day shifted by one.
    if (!code) {
      throw new Error(`Unrecognised coverage hours day of week: ${day}`);
    }

    return code;
  });
}

// Stored minutes are wall clock in the property's zone. formatTimeDisplay parses the
// ISO string and converts to the viewer's zone, so building the Date in local time is
// what makes that conversion a no-op; a UTC-built date shifts by the viewer's offset.
export function minutesToLocalIso(minutesPastMidnight: number): string {
  const hours = Math.floor(minutesPastMidnight / 60);
  const minutes = minutesPastMidnight % 60;

  return new Date(2000, 0, 1, hours, minutes).toISOString();
}

export function formatCoverageHours(schedule: CoverageHoursSchedule): string {
  const days = formatDays(toDayCodes(schedule.daysOfWeek));
  const start = formatTimeDisplay(minutesToLocalIso(schedule.startMinute));
  const end = formatTimeDisplay(minutesToLocalIso(schedule.endMinute));

  return days ? `${days}, ${start}-${end}` : `${start}-${end}`;
}
